import { z } from 'zod';

/** 一覧のカテゴリフィルタ。`all` はカテゴリ絞り込みなしで、タブ行の右端に置くため末尾に並べる。 */
export const PAYROLL_INPUT_SNAPSHOT_CATEGORY_TABS = ['people', 'attendances', 'organization', 'contracts', 'benefits', 'commuting-expenses', 'all'] as const;
export type PayrollInputSnapshotCategoryTab = (typeof PAYROLL_INPUT_SNAPSHOT_CATEGORY_TABS)[number];
export const PayrollInputSnapshotSearchSchema = z.object({
  sourceCategory: z.enum(PAYROLL_INPUT_SNAPSHOT_CATEGORY_TABS).default('all'),
  freeText: z.string().default('')
});
export type PayrollInputSnapshotSearchParams = z.infer<typeof PayrollInputSnapshotSearchSchema>;